import { formatDistanceToNow } from "date-fns";

export const niceDate = (date) => {
  const nice = formatDistanceToNow(date);
  if (nice === "less than a minute") {
    return "just now";
  }
  return `${nice} ago`;
};

export const localToUtcJustDate = (date) =>
  new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
  );

export const utcToLocalJustDate = (date) =>
  new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    0,
    0,
    0
  );
